import ImgPreviewComponent from './ImgPreview'

const ImgPreview = {}

ImgPreview.install = Vue => {
  const ImgConstructor = Vue.extend(ImgPreviewComponent)

  const instance = new ImgConstructor()

  instance.$mount(document.createElement('div'))

  document.body.appendChild(instance.$el)

  Vue.prototype.$imgPreview = (e) => {
    instance.target = e.currentTarget
    instance.dateimgs = instance.target.getAttribute('data-img')
    if (instance.dateimgs != '') {
      instance.imgs = instance.dateimgs.split(',')
      instance.isShowImageDialog = true
    }else{
      Vue.prototype.message({
          message: '暂无图片可预览',
          type: 'warning'
        });
    }
  }
}

export default ImgPreview



// WEBPACK FOOTER //
// ./src/components/ImgPreivewDialog/index.js